export default "__VITE_ASSET__CIBy9Ra$__"